import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * A pipe to transform HTML to safe HTML
 */
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   * Constructor
   * @param sanitizer - A reference to the DomSanitizer service
   */
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Transform the passed HTML
   * @param html - The HTML to transform
   * @returns The transformed HTML
   */
  public transform(html) {
    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    return sanitizedHtml;
  }
}
